import React, { useEffect, useState } from "react";
import "./Product_info.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Demo_Product from "../../home/demo_product/Demo_Product";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useNavigate } from "react-router-dom";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import {
  appSetup,
  getAllCategories,
} from "../../../features/master/masterSlice";
import { getHomeBanner } from "../../../features/home/homeSlice";
import {
  postCart,
  getAllCart,
  getCart,
} from "../../../features/cart/cartSlice";
import Demo_ProductCategory from "../../home/demo_product/Demo_ProductCategory";
import { variant_type } from "../../../utils/common";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Product_info = ({
  selectedVariant,
  setSelectedVariant,
  activeSize,
  activeTriple,
  activeMetal,
  setActiveTriple,
  setActiveSize,
  setActiveMetal,
  product,
  itemID,
  avg_rating,
}) => {
  const [activeIndex, setActiveIndex] = useState(0); // default first card active
  const [activeIndex2, setActiveIndex2] = useState(0); // default first card active

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product-cart?item_id=${itemID}`);
  };

  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const cartData = useSelector((state) => state.cart.allCarts);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    dispatch(getAllCart(isSignIn));
  }, [dispatch, isSignIn]);

  const cartItem = cartData?.data?.find((item) => {
    return (
      Number(item?.product_id) === Number(product?.id) &&
      Number(item?.variant_id || 0) === Number(activeMetal?.id || 0) &&
      Number(item?.d_variant_id || 0) === Number(activeSize?.id || 0) &&
      Number(item?.t_variant_id || 0) === Number(activeTriple?.id || 0)
    );
  });

  const cartQty = Number(cartItem?.quantity || 0);

  const currentStock =
    activeTriple?.stock != null
      ? Number(activeTriple.stock)
      : activeSize?.stock != null
      ? Number(activeSize.stock)
      : activeMetal?.general_stock != null
      ? Number(activeMetal.general_stock)
      : Number(product?.stock || 0);
  const availableStock = Math.max(currentStock - cartQty, 0);

  const addToCart = async () => {
    const qtyToAdd = quantity - cartQty;

    // if (qtyToAdd <= 0) {
    //   return;
    // }

    // if (cartQty >= currentStock) {
    //   return;
    // }

    if (cartQty >= currentStock && currentStock > 0) {
      // handleClick(); // go to cart page
      return;
    }

    try {
      const data = {
        item_id: itemID,
        quantity: quantity,
        product_id: product?.id,
        // variant_type_id: product?.variant_type_id || variant_type.Single,
        variant_type_id: activeTriple?.id
          ? variant_type.Triple
          : activeSize?.id
          ? variant_type.Double
          : variant_type.Single,
        product_name: product?.name,
        image: selectedVariant?.image || product?.image,
        tax_percentage: product?.tax_percentage,
        variant_name: selectedVariant?.name,
        mrp: selectedVariant?.mrp,
        price: selectedVariant?.price,
        description: selectedVariant?.description,
        // variant_id:
        //   !product?.variant_type_id ||
        //   Number(product?.variant_type_id) === Number(variant_type.Single)
        //     ? selectedVariant?.id
        //     : null,
        // d_variant_id:
        //   Number(product?.variant_type_id) === Number(variant_type.Double)
        //     ? selectedVariant?.id
        //     : null,
        // t_variant_id:
        //   Number(product?.variant_type_id) === Number(variant_type.Triple)
        //     ? selectedVariant?.id
        //     : null,

        variant_id: activeMetal?.id || null,
        d_variant_id: activeSize?.id || null,
        t_variant_id: activeTriple?.id || null,
      };

      const res = await dispatch(
        postCart({
          data,
          isSignIn,
        }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        // handleClick();
        await dispatch(getAllCart(isSignIn));

        setSuccessMessage("Product added to cart successfully!");
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Auto select first available variant
  // useEffect(() => {
  //   if (activeMetal?.Double_Variants?.length > 0) {
  //     setSelectedVariant(activeMetal?.Double_Variants?.[0]);
  //     setActiveSize(activeMetal?.Double_Variants?.[0]);
  //   }
  // }, [activeMetal]);

  // useEffect(() => {
  //   if (activeSize?.Triple_Variants?.length > 0) {
  //     setSelectedVariant(activeSize?.Triple_Variants?.[0]);
  //     setActiveTriple(activeSize?.Triple_Variants?.[0]);
  //   }
  // }, [activeSize]);

  // useEffect(() => {
  //   if (product?.Product_Variants?.length > 0) {
  //     const firstVariant = product.Product_Variants[0];

  //     setActiveMetal(firstVariant);

  //     if (Number(product?.variant_type_id) === Number(variant_type.Single)) {
  //       setSelectedVariant(firstVariant);
  //     }
  //   }
  // }, [product]);

  useEffect(() => {
    setQuantity(cartQty > 0 ? cartQty : 1);
  }, [activeMetal, activeSize, activeTriple, cartQty]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "$";

  // const currentStock = Number(
  //   selectedVariant?.stock ||
  //     selectedVariant?.general_stock ||
  //     activeMetal?.general_stock ||
  //     0,
  // );

  const noStock = currentStock <= 0;
  const isOutOfStock = availableStock > 0 && quantity >= availableStock;

  const displayVariant = activeTriple || activeSize || activeMetal;

  const fullyAddedToCart = cartQty >= currentStock && currentStock > 0;
  const reachedMaxQuantity = quantity >= currentStock && currentStock > 0;

  const getColorFromName = (name = "") => {
    const colorMap = {
      // Basic
      Black: "#000000",
      White: "#FFFFFF",
      WH: "#FFFFFF",

      Red: "#FF0000",
      Blue: "#0000FF",
      Green: "#008000",
      GR: "#008000",

      Yellow: "#FFFF00",

      Pink: "#FFC0CB",
      "Light Pink": "#FFD6E7",
      "Rani Pink": "#E75480",

      Purple: "#800080",
      Violet: "#8F00FF",

      Maroon: "#800000",

      Mint: "#98FF98",
      LightGreen: "#90EE90",

      Peach: "#FFDAB9",

      Honey: "#D4A24C",

      "Sky blue": "#87CEEB",
      "Sky Blue": "#87CEEB",

      Mehndi: "#556B2F",

      // Gold
      Gold: "#C89B45",
      "Golden Med": "#C89B45",

      // Polish
      RODIUM: "#C0C0C0",

      // Ruby
      RUBY: "#9B111E",
      RB: "#9B111E",

      // Multi
      Multicolor: "linear-gradient(45deg, red, yellow, green, blue)",

      // Two Colors
      "RB/WH": "linear-gradient(45deg, #9B111E 50%, #FFFFFF 50%)",
      "RUBY/WHITE": "linear-gradient(45deg, #9B111E 50%, #FFFFFF 50%)",

      "RB/GR": "linear-gradient(45deg, #9B111E 50%, #008000 50%)",

      "RUBY/GREEN": "linear-gradient(45deg, #9B111E 50%, #008000 50%)",

      "RG/WH": "linear-gradient(45deg, #E0BFB8 50%, #FFFFFF 50%)",

      "RA/GR": "linear-gradient(45deg, #FF9999 50%, #008000 50%)",

      "Mint/Green": "linear-gradient(45deg, #98FF98 50%, #008000 50%)",

      "Mint/Pink": "linear-gradient(45deg, #98FF98 50%, #FFC0CB 50%)",

      // Three Colors
      "RB/GR/WH":
        "linear-gradient(90deg, #9B111E 33%, #008000 33%, #008000 66%, #FFFFFF 66%)",

      "RB-GR-WH":
        "linear-gradient(90deg, #9B111E 33%, #008000 33%, #008000 66%, #FFFFFF 66%)",

      "RB/GR/PL":
        "linear-gradient(90deg, #9B111E 33%, #008000 33%, #008000 66%, #FFC0CB 66%)",
    };

    return colorMap[name?.trim()] || "#C89B45";
  };

  // Picks the first variant that has images so the product image never disappears
  const pickVariantWithImages = (...variants) =>
    variants.find((v) => v?.Product_Images?.length > 0) ||
    variants.find(Boolean) ||
    {};

  const getPolishColor = (name = "") => {
    const polishMap = {
      Gold: "#C89B45",

      Silver: "#C0C0C0",

      "Rose Gold": "#E0BFB8",

      Rhodium: "#D3D3D3",
      RODIUM: "#D3D3D3",

      Mehndi: "#556B2F",

      MICRO: "#B8860B",

      MATT: "#A89F91",

      "ANTIQUE MAT": "#8B7355",
    };

    return polishMap[name?.trim()] || "#C89B45";
  };

  const selectedSku =
    activeTriple?.sku_code ||
    activeSize?.sku_code ||
    activeMetal?.sku_code ||
    product?.sku_code;

  useEffect(() => {
    if (!fullyAddedToCart && reachedMaxQuantity) {
      toast.error(
        "You have selected the maximum available quantity for this variant.",
      );
    }
  }, [fullyAddedToCart, reachedMaxQuantity]);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const discountPercentage =
    Number(product?.prod_discount) > 0
      ? Number(product.prod_discount)
      : Number(product?.p_category?.cat_discount) > 0
      ? Number(product.p_category.cat_discount)
      : Number(app_setup?.global_discount) > 0
      ? Number(app_setup.global_discount)
      : 0;

  return (
    <section className="Product_info">
      <div className="text_holder">
        <h4 className="para_secondary_text">
          {product?.name} {"("}
          {product?.design_id}
          {")"}
        </h4>

        <h6 className="para_secondary_text mb-3">SKU Code: {selectedSku}</h6>

        <div className="price_holder">
          {/* <h6 className="para_text">
            {symbol} {Number((displayVariant?.price || 0) * rate).toFixed(2)}{" "}
            {product?.prod_discount && (
              <>
                <span className="discount-price">
                  {" "}
                  {product?.prod_discount}(%) {"  "}Off
                </span>
              </>
            )}
          </h6> */}

          {/* <h6 className="para_text">
            {(() => {
              const discountPercentage =
                Number(product?.prod_discount) > 0
                  ? Number(product.prod_discount)
                  : Number(product?.p_category?.cat_discount) > 0
                  ? Number(product.p_category.cat_discount)
                  : Number(app_setup?.global_discount) > 0
                  ? Number(app_setup.global_discount)
                  : 0;

              const originalPrice = Number(displayVariant?.price || 0);

              const discountedPrice =
                originalPrice * (1 - discountPercentage / 100);

              return discountPercentage > 0 ? (
                <>
                  <span
                    style={{
                      textDecoration: "line-through",
                      marginRight: "8px",
                      fontWeight: "400",
                    }}
                  >
                    {symbol} {(originalPrice * rate).toFixed(2)}
                  </span>
                  {symbol} {(discountedPrice * rate).toFixed(2)}
                </>
              ) : (
                <>
                  {symbol} {(originalPrice * rate).toFixed(2)}
                </>
              );
            })()}
          </h6> */}

          <h6 className="para_text">
            {(() => {
              const originalPrice = Number(displayVariant?.price || 0);

              const discountedPrice =
                originalPrice * (1 - discountPercentage / 100);

              return discountPercentage > 0 ? (
                <>
                  <span
                    style={{
                      textDecoration: "line-through",
                      marginRight: "8px",
                      fontWeight: "400",
                    }}
                  >
                    {symbol} {(originalPrice * rate).toFixed(2)}
                  </span>
                  {symbol} {(discountedPrice * rate).toFixed(2)}
                  <span
                    className="discount-price"
                    style={{
                      marginLeft: "10px",
                      color: "#fbfcfb",
                      fontWeight: "600",
                    }}
                  >
                    {Number.isInteger(discountPercentage)
                      ? discountPercentage
                      : discountPercentage.toFixed(2)}
                    % Off
                  </span>
                </>
              ) : (
                <>
                  {symbol} {(originalPrice * rate).toFixed(2)}
                </>
              );
            })()}
          </h6>

          <span className="mrp_holder">(Inclusive of all taxes)</span>
        </div>

        <br />

        {/* {product?.prod_discount && (
          <>
         <h6 className="para_secondary_text mb-3">Product Discount: {product?.prod_discount}(%)</h6>
         </>
          )} */}
      </div>

      <div>
        {product?.Product_Variants?.length > 0 && (
          <div className="quantity_holder">
            <p className="type_text">
              Polish : <strong>{activeMetal?.name}</strong>
            </p>

            <div className="polish-options">
              {product?.Product_Variants?.map((option) => {
                const polishColor = getPolishColor(option?.name);

                return (
                  <div
                    key={option?.id}
                    className={`polish-circle ${
                      activeMetal?.id === option?.id ? "active" : ""
                    }`}
                    onClick={() => {
                      const firstSize = option?.Double_Variants?.[0] || null;
                      const firstTriple = firstSize?.Triple_Variants?.[0] || null;

                      setActiveMetal(option);
                      setActiveSize(firstSize);
                      setActiveTriple(firstTriple);
                      setSelectedVariant(
                        pickVariantWithImages(firstTriple, firstSize, option),
                      );
                    }}
                    title={option?.name}
                  >
                    <span
                      className="polish-fill"
                      style={{
                        backgroundColor: polishColor,
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/*Color Code */}
        {product?.Product_Variants?.find((v) => v.id === activeMetal?.id)
          ?.Double_Variants?.length > 0 && (
          <div className="quantity_holder">
            <p className="type_text">
              Colour : <strong>{activeSize?.name}</strong>
            </p>

            <div className="color-options">
              {product?.Product_Variants?.find(
                (v) => v.id === activeMetal?.id,
              )?.Double_Variants?.map((item) => {
                const colorValue = getColorFromName(item?.name);

                return (
                  <div
                    key={item?.id}
                    className={`color-circle ${
                      activeSize?.id === item?.id ? "active" : ""
                    }`}
                    onClick={() => {
                      const firstTriple = item?.Triple_Variants?.[0] || null;

                      setActiveSize(item);
                      setActiveTriple(firstTriple);
                      setSelectedVariant(
                        pickVariantWithImages(firstTriple, item, activeMetal),
                      );
                    }}
                    title={item?.name}
                  >
                    <span
                      className="color-fill"
                      style={
                        colorValue.includes("gradient")
                          ? { backgroundImage: colorValue }
                          : { backgroundColor: colorValue }
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Size */}
        {/* {product?.Product_Variants?.find(
          (v) => v.id === activeMetal?.id,
        )?.Double_Variants?.find((s) => s.id === activeSize?.id)
          ?.Triple_Variants?.length > 0 && (
          <div className="quantity_holder">
            <p className="type_text">Size</p>

            <div className="all_size_btns_holder">
              {product?.Product_Variants?.find((v) => v.id === activeMetal?.id)
                ?.Double_Variants?.find((s) => s.id === activeSize?.id)
                ?.Triple_Variants?.map((item1) => (
                  <div className="col-sm-1 p-1 col-2 mb-3" key={item1?.id}>
                    <div
                      className={`quantity_box_holder ${
                        activeTriple?.id === item1?.id ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveTriple(item1);
                        setSelectedVariant(item1);
                      }}
                    >
                      <div className="info_holder">
                        <h5>{item1?.name}</h5>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )} */}

        {product?.Product_Variants?.find(
          (v) => v.id === activeMetal?.id,
        )?.Double_Variants?.find((s) => s.id === activeSize?.id)
          ?.Triple_Variants?.length > 0 && (
          <div className="quantity_holder">
            <p className="type_text">Size</p>

            <div className="all_size_btns_holder">
              {[
                ...(product?.Product_Variants?.find(
                  (v) => v.id === activeMetal?.id,
                )?.Double_Variants?.find((s) => s.id === activeSize?.id)
                  ?.Triple_Variants || []),
              ]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((item1) => (
                  <div className="div_holder" key={item1?.id}>
                    <div
                      className={`quantity_box_holder ${
                        activeTriple?.id === item1?.id ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveTriple(item1);
                        setSelectedVariant(
                          pickVariantWithImages(item1, activeSize, activeMetal),
                        );
                      }}
                    >
                      <div className="info_holder">
                        <h5>{item1?.name}</h5>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      <div className="prod_description"></div>

      <div className="btn_holder">
        <div className="add_cart_btn">
          {/* <Green_btn
            btnText="ADD TO CART"
            product={product}
            onClick={addToCart}
            quantity={quantity}
            setQuantity={setQuantity}
            selectedVariant={selectedVariant}
          /> */}
          <Green_btn
            btnText={noStock ? "OUT OF STOCK" : "ADD TO CART"}
            product={product}
            onClick={!noStock ? addToCart : undefined}
            disabled={noStock}
            quantity={quantity}
            setQuantity={setQuantity}
            selectedVariant={selectedVariant}
          />
        </div>

        <div className="d-flex flex-column align-items-start">
          {!noStock && (
            <>
              <Increment_decrement_btn_holder
                quantity={quantity}
                setQuantity={(updater) => {
                  const newQuantity =
                    typeof updater === "function" ? updater(quantity) : updater;

                  if (newQuantity > currentStock) {
                    setQuantity(currentStock);
                    return;
                  }

                  setQuantity(newQuantity);
                }}
              />

              {fullyAddedToCart && (
                <p className="text-danger fw-bold mt-2 mb-0">
                  Maximum available quantity already added to cart.
                </p>
              )}

              <ToastContainer position="top-right" autoClose={3000} />
            </>
          )}
        </div>
      </div>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText={successMessage}
      />
    </section>
  );
};

export default Product_info;
